import { PortableTextBlockComponent } from '@portabletext/react'

export const Blockquote: PortableTextBlockComponent = ({ children }) => {
  return (
    <p className='pl-[10px] border-l-[7px] border-[#99BE8C] rounded-[10px]'>
      {children}
    </p>
  )
}
